import { Dispatch, SetStateAction, useCallback } from "react"
import { makeStyles } from "tss-react/mui"
import { DialogContent, Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../StandardDialog"
import { Instruction } from "../../../layouts/components/supportInstructions/instructionTypes"
import { InstructionAlert } from "../../../layouts/components/supportInstructions/InstructionAlert"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "0 3.75rem 3.75rem 3.75rem",
    },
    dialogBox: {
        gap: "1.5rem",
    },
    dialogTitle: {
        fontSize: "2.5rem",
        fontWeight: 600,
        color: theme.palette.tailwind.slate[700],
    },
}))

type InstructionDialogProps = Readonly<{
    instructions?: Array<Instruction>
    dialogState: boolean
    setDialogState: Dispatch<SetStateAction<boolean>>
}>

export function InstructionDialog({ dialogState, setDialogState, instructions }: InstructionDialogProps) {
    const { classes } = useStyles()

    const handleClose = useCallback(() => {
        setDialogState((prev) => !prev)
    }, [setDialogState])

    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="support-instructions-button">
                    <Typography className={classes.dialogTitle}>Instructions</Typography>
                </LocalizedStrict>
            }
            open={dialogState}
            onClose={handleClose}
            maxWidthProp="lg"
            scroll="body"
        >
            <DialogContent className={classes.dialogContent}>
                <Grid container flexDirection="column" className={classes.dialogBox}>
                    {instructions?.map((instruction, index) => (
                        <InstructionAlert
                            key={index}
                            status={instruction.type}
                            title={instruction.title}
                            text={instruction.text}
                        />
                    ))}
                </Grid>
            </DialogContent>
        </StandardDialog>
    )
}
